import React from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { handleAddCredit } from '../../redux/actions';
import { Button, Input } from '../index';

import { AddSection, AddDescription, AddInputItem, AddInputButtonContainer, Message } from './styles';

const PromoScheme = Yup.object().shape({
  promoCode: Yup.string().required('Code is required'),
});

const AddCredit = ({ onFormSubmit, error, success }) => (
  <AddSection>
    <Formik
      initialValues={{
        promoCode: '',
      }}
      onSubmit={values => onFormSubmit(values.promoCode)}
      validationSchema={PromoScheme}
    >
      {({errors, touched, handleBlur, handleChange, values}) => (
        <Form>
          <AddInputItem>
            <p>Add credit*</p>
            <Input
              htmlType="text"
              name="promoCode"
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.promoCode}
              hasError={errors.promoCode && touched.promoCode}
              errors={errors.promoCode}
              placeholder="Enter gift code or credit code"
            />
          </AddInputItem>
          {success && <Message style={{ color: '#11d17d' }}>Great! Credits were added to your account</Message>}
          {error && <Message style={{ color: '#ff4e72' }}>{error}</Message>}
          <AddDescription>
            * DayAxe credit is a form of payment which can be used
            to purchase products on this site. If you received a Gift or
            Credit Code enter it.
          </AddDescription>
          <AddInputButtonContainer>
            <Button theme="primary" htmlType="submit">
              Add credit
            </Button>
          </AddInputButtonContainer>
        </Form>
      )}
    </Formik>
  </AddSection>
);

AddCredit.propTypes = {
  onFormSubmit: PropTypes.func,
  error: PropTypes.string,
  success: PropTypes.bool,
};

const mapStateToProps = state => ({
  error: state.user.errors.addCredit,
  success: state.user.success.addCredit,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFormSubmit: handleAddCredit,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddCredit);
